import { TextDecorations } from "@quickpoint.me/shared";

export const mdToTagMap: Map<
    typeof TextDecorations[keyof typeof TextDecorations],
    { open: string; close: string }
> = new Map();

mdToTagMap.set(TextDecorations.underline, {
    open: `<span class="text-modifier ${TextDecorations.underline}">`,
    close: "</span>",
});
// mdToTagMap.set("~", {
//   open: "<span class='text-modifier ~:'>",
//   close: "</span>",
// });

mdToTagMap.set(TextDecorations.shadow, {
    open: `<span class='text-modifier shadow ${TextDecorations.shadow}'>`,
    close: "</span>",
});

mdToTagMap.set(TextDecorations.bold, {
    open: `<strong class="text-modifier ${TextDecorations.bold}">`,
    close: "</strong>",
});

mdToTagMap.set(TextDecorations.italic, {
    open: `<i class="text-modifier ${TextDecorations.italic}">`,
    close: "</i>",
});